import { SlotPayout } from "../types/SlotPayout";
import { SlotPayoutType, SlotReelSymbol } from "./enum/slot";

import healthIcon from "../assets/imgs/slot/heart.png";
import bodyguardIcon from "../assets/imgs/slot/bodyguard.png";
import helperIcon from "../assets/imgs/slot/helperbot.png";
import cashIcon from "../assets/imgs/slot/cash.png";
import bulletIcon from "../assets/imgs/slot/bullets.png";
import crateIcon from "../assets/imgs/slot/crate.png";
import mafiaIcon from "../assets/imgs/slot/mafiatoken.png";
import keyIcon from "../assets/imgs/slot/key.png";
import ogIcon from "../assets/imgs/slot/OG.png";
import diamondIcon from "../assets/imgs/slot/diamond.png";
import jackpot7Icon from "../assets/imgs/slot/7.png";

export const SlotPayouts: SlotPayout[] = [
  // Loss
  {
    from: 0,
    to: 47450,
    multi: 0,
    payoutType: SlotPayoutType.Loss,
    symbol: SlotReelSymbol.Random,
    symbolCount: 0,
  },
  // Health (Low win)
  {
    from: 47451,
    to: 53838,
    multi: 0.05,
    payoutType: SlotPayoutType.LowWin,
    symbol: SlotReelSymbol.Health,
    symbolCount: 2,
  },
  // Bodyguard (Low win)
  {
    from: 53839,
    to: 59935,
    multi: 0.1,
    payoutType: SlotPayoutType.LowWin,
    symbol: SlotReelSymbol.Bodyguard,
    symbolCount: 2,
  },
  // Helper bot (Low win)
  {
    from: 59936,
    to: 65767,
    multi: 0.15,
    payoutType: SlotPayoutType.LowWin,
    symbol: SlotReelSymbol.HelperBot,
    symbolCount: 2,
  },
  // Cash (Low win)
  {
    from: 65768,
    to: 70926,
    multi: 0.3,
    payoutType: SlotPayoutType.LowWin,
    symbol: SlotReelSymbol.Cash,
    symbolCount: 2,
  },
  // Health (Low win, higher multiplier)
  {
    from: 70927,
    to: 75397,
    multi: 0.5,
    payoutType: SlotPayoutType.LowWin,
    symbol: SlotReelSymbol.Health,
    symbolCount: 3,
  },
  // Bullets (Low win)
  {
    from: 75398,
    to: 79868,
    multi: 0.5,
    payoutType: SlotPayoutType.LowWin,
    symbol: SlotReelSymbol.Bullets,
    symbolCount: 2,
  },
  // Bodyguard (Low win, higher multiplier)
  {
    from: 79869,
    to: 83221,
    multi: 1,
    payoutType: SlotPayoutType.LowWin,
    symbol: SlotReelSymbol.Bodyguard,
    symbolCount: 3,
  },
  // Crate (Low win)
  {
    from: 83222,
    to: 86574,
    multi: 1,
    payoutType: SlotPayoutType.LowWin,
    symbol: SlotReelSymbol.Crate,
    symbolCount: 2,
  },
  // Helper bot (Medium win)
  {
    from: 86575,
    to: 89256,
    multi: 1.5,
    payoutType: SlotPayoutType.MedWin,
    symbol: SlotReelSymbol.HelperBot,
    symbolCount: 3,
  },
  // MAFIA token (Medium win)
  {
    from: 89257,
    to: 91938,
    multi: 1.5,
    payoutType: SlotPayoutType.MedWin,
    symbol: SlotReelSymbol.MafiaToken,
    symbolCount: 2,
  },
  // Keys (Medium win)
  {
    from: 91939,
    to: 93854,
    multi: 2.5,
    payoutType: SlotPayoutType.MedWin,
    symbol: SlotReelSymbol.Keys,
    symbolCount: 2,
  },
  // Cash (Medium win)
  {
    from: 93855,
    to: 95530,
    multi: 3,
    payoutType: SlotPayoutType.MedWin,
    symbol: SlotReelSymbol.Cash,
    symbolCount: 3,
  },
  // Bullets (Medium win)
  {
    from: 95531,
    to: 96647,
    multi: 5,
    payoutType: SlotPayoutType.MedWin,
    symbol: SlotReelSymbol.Bullets,
    symbolCount: 3,
  },
  // OG NFT (Medium win)
  {
    from: 96648,
    to: 97764,
    multi: 5,
    payoutType: SlotPayoutType.MedWin,
    symbol: SlotReelSymbol.OGNFT,
    symbolCount: 2,
  },
  // Crate (Big win)
  {
    from: 97765,
    to: 98373,
    multi: 10,
    payoutType: SlotPayoutType.BigWin,
    symbol: SlotReelSymbol.Crate,
    symbolCount: 3,
  },
  // Diamonds (Big win)
  {
    from: 98374,
    to: 98982,
    multi: 10,
    payoutType: SlotPayoutType.BigWin,
    symbol: SlotReelSymbol.Diamonds,
    symbolCount: 2,
  },
  // MAFIA token (Big win)
  {
    from: 98983,
    to: 99401,
    multi: 15,
    payoutType: SlotPayoutType.BigWin,
    symbol: SlotReelSymbol.MafiaToken,
    symbolCount: 3,
  },
  // Keys (Big win)
  {
    from: 99402,
    to: 99658,
    multi: 25,
    payoutType: SlotPayoutType.BigWin,
    symbol: SlotReelSymbol.Keys,
    symbolCount: 3,
  },
  // OG NFT (Jackpot win)
  {
    from: 99659,
    to: 99789,
    multi: 50,
    payoutType: SlotPayoutType.JackpotWin,
    symbol: SlotReelSymbol.OGNFT,
    symbolCount: 3,
  },
  // Jackpot 7 (Jackpot win, lower range)
  {
    from: 99790,
    to: 99920,
    multi: 50,
    payoutType: SlotPayoutType.JackpotWin,
    symbol: SlotReelSymbol.Jackpot7,
    symbolCount: 2,
  },
  // Diamondss (Jackpot win)
  {
    from: 99921,
    to: 99986,
    multi: 100,
    payoutType: SlotPayoutType.JackpotWin,
    symbol: SlotReelSymbol.Diamonds,
    symbolCount: 3,
  },
  // Jackpot 7 (Jackpot win, higher range)
  {
    from: 99987,
    to: 99999,
    multi: 500,
    payoutType: SlotPayoutType.JackpotWin,
    symbol: SlotReelSymbol.Jackpot7,
    symbolCount: 3,
  },
];

export const SlotPayoutSummary = [
  { name: "Health", symbol: SlotReelSymbol.Health, twoX: 0.05, threeX: 0.5 },
  { name: "Bodyguard", symbol: SlotReelSymbol.Bodyguard, twoX: 0.1, threeX: 1 },
  {
    name: "Helper bot",
    symbol: SlotReelSymbol.HelperBot,
    twoX: 0.15,
    threeX: 1.5,
  },
  { name: "Cash", symbol: SlotReelSymbol.Cash, twoX: 0.3, threeX: 3 },
  { name: "Bullets", symbol: SlotReelSymbol.Bullets, twoX: 0.5, threeX: 5 },
  { name: "Crate", symbol: SlotReelSymbol.Crate, twoX: 1, threeX: 10 },
  {
    name: "MAFIA token",
    symbol: SlotReelSymbol.MafiaToken,
    twoX: 1.5,
    threeX: 15,
  },
  { name: "Keys", symbol: SlotReelSymbol.Keys, twoX: 2.5, threeX: 25 },
  { name: "OG NFT", symbol: SlotReelSymbol.OGNFT, twoX: 5, threeX: 50 },
  { name: "Diamond", symbol: SlotReelSymbol.Diamonds, twoX: 10, threeX: 100 },
  { name: "Jackpot 7", symbol: SlotReelSymbol.Jackpot7, twoX: 50, threeX: 500 },
];

export const SlotSymbolIcons = [
  "",
  healthIcon,
  bodyguardIcon,
  helperIcon,
  cashIcon,
  bulletIcon,
  crateIcon,
  mafiaIcon,
  keyIcon,
  ogIcon,
  diamondIcon,
  jackpot7Icon,
];

export const SlotReelSymbols = [
  SlotReelSymbol.Health,
  SlotReelSymbol.Bodyguard,
  SlotReelSymbol.HelperBot,
  SlotReelSymbol.Cash,
  SlotReelSymbol.Bullets,
  SlotReelSymbol.Crate,
  SlotReelSymbol.MafiaToken,
  SlotReelSymbol.Keys,
  SlotReelSymbol.OGNFT,
  SlotReelSymbol.Diamonds,
  SlotReelSymbol.Jackpot7,
];

// Slot animation duration in milliseconds
export const SlotPayoutAnimationDuration: Record<SlotPayoutType, number> = {
  [SlotPayoutType.Loss]: 0,
  [SlotPayoutType.LowWin]: 1000 * 1,
  [SlotPayoutType.MedWin]: 1000 * 1,
  [SlotPayoutType.BigWin]: 1000 * 10,
  [SlotPayoutType.JackpotWin]: 1000 * 13,
};
